module.exports = __webpack_public_path__ + "img/category-botany-reverse.add13e27.svg";